import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams} from "react-router-dom";
import { Divider, Grid, Table, TableBody, TableContainer, TableHead } from "@mui/material";
import { GreenColorButton, PrimeGrayBorderColorButton, RedColorButton, StatusStyle } from "../../Components/MaterialButtonStyle/StyleButton";
import { OnlyDateTimeConverter } from "../../Components/Helpers/DateTimeConverter";
import { StyledTableCell, StyledTableRow } from "../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import TextAreaField from "../../Components/CustomInputs/TextArea";
import CustomModal from "../../Components/Modal/CustomModal";
import { RejectionsInfo } from "../Settings/DataFile/Data";
import { BloodGroupList, AppointmentDataOtherInfomarion, CandiateDetaildData, ConstableData, PhysicalData, QualificationLevelData, } from "./Data/ConstableData";
import VerifyCertificateDetailsModal from "./Modal/VerifyCertificateDetailsModal";
import TakePhysicalDataDetails from "./Modal/TakePhysicalDataDetails";
import TakeMedicalScreeningDetails from "./Modal/TakeMedicalScreeningDetails";
import CallLetterModal from "./Modal/CallLetterModal";
import FinalAppointmentDetails from "./Modal/FinalAppointmentDetails";
import ComputerBasedTest from "./Modal/ComputerBasedTest";
import { GetMethod, S3Upload } from "../../Helper/api";
import OfferLetterModal from "./Modal/OfferLetterModal"
const ApplicationProcess = ({MedicaltestsList,MedicalDataDetails,computerTestlist, activeStep, ApplicationBasicDetails, GetApplicationDetails, applicationDetail,physicalTest,PhysicalDataDetails,CandidateDetail }) => {
  const paramss = useParams();
  const [physicalDataChild, setPhysicalDataChild] = useState(PhysicalData);
  const [attachmentList, setAttachmentList] = useState([{ id: 1, attachmentName: "", fileUrl: "", fileName: "", fileType: "" }])
  const [attachmentLoader, setAttachmentLoader] = useState(false)
  const [remarks, setRemarks] = useState("");
  const [medicalScreening, setMedicalScreening] = useState(false)
  const [appointmentOfferLetter, setAppointmentOfferLetter] = useState(false)
  const [primaryDuties, setPrimaryDuties] = useState("");
  const [takePhysicalModal, setTakePhysicalModal] = useState(false);
  const [roleCheckBoxData, setRoleCheckBoxData] = useState({
    candidateFit: false,
    candidateNotFit: false,
  });
  const [offerLetterCheckBoxData, setOfferLetterCheckBoxData] = useState({
    candidatePersonalInfo: false, candidateRequirement: false,
    candidateApplicationStage: false, candidateAllDocument: false,
    candidateFinalAppointment: false
  })
  const [appointmentData, setAppointmentData] = useState(AppointmentDataOtherInfomarion);
  const [qualificationLevelChildData, setQualificationLevelChildData] = useState(QualificationLevelData);
  const [candiateDetaildData, setCandiateDetaildData] = useState(CandiateDetaildData);
  const [certificateVerifyModal, setCertificateVerifyModal] = useState(false);
  const [deficiencies, setDeficiencies] = useState("");
  const [offerLetterModal, setOfferLetterModal] = useState(false)
  const [physicalDetails, setPhysicalDetails] = useState([]);
  const [applicationCopyDetails, setApplicationCopyDetails] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [physicalTestSupervisorDetails, setPhysicalTestSupervisorDetails] = useState([])
  const [medicalTestSupervisorDetails, setMedicalTestSupervisorDetails] = useState([]);
  const [computeTestDetails, setComputeTestDetails] = useState([]);
  const [finalResultDetails, setFinalResultDetails] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [callLetter, setCallLetter] = useState(false);
  const [computerBasedModal, setComputerBasedModal] = useState(false);
  const callLetterHeading = useState("")
  const [Selectedtests, setSelectedtests] = useState("")
  const [CharmanName, setCharmanName] = useState("")
  const [CharmanSignatures, setCharmanSignatures] = useState("")
  const CalletterName = useState("")
  const [WorkFlow, setWorkFlow] = useState([])

  const UsersType =localStorage.getItem("@userType")

  const callLetterDetails = {
    registerNumber: "NPSCASP04617",
    applicationNumber: "NPSC-ASP-04617",
    nextOfKinName: "YUSIF ISHAQ DALAWA",
    centerName: "National Police Academy",
    venueAddress: "Plot 1, Police Service Commission Road, Abuja, Nigeria",
    salutation: "Mr.",
    name: "Temitope Adeyemi",
    scheduleDate: 1734756337000
  }
  useEffect(()=>{
    setPhysicalDetails(PhysicalDataDetails)
    if(physicalTest?.length>0){
      let datas =[...physicalTest]
      if(datas?.physical_test_current_status!="pending"){
        datas.push({
          "physical_test_id": "11",
          "physical_test_name": "Call Letter for Physical",
          "physical_test_created_at": datas[0].physical_test_created_at,
          "physical_test_updated_on": datas[0].physical_test_updated_on,
          "physical_test_status": datas[0].physical_test_status,
          "physical_test_current_status": "Call Letter Received",
          "application_id":  datas[0].application_id,
          "applicant_id":  datas[0].applicant_id,
          "test_reject_reason": "",
          "test_type": "",
          "status": "Call Letter Received"
        })
        setPhysicalTestSupervisorDetails(datas)
      }else{
        setPhysicalTestSupervisorDetails(physicalTest)
      }
    }else{
      setPhysicalTestSupervisorDetails(physicalTest)
    }
  },[physicalTest])
  useEffect(()=>{
    if(applicationDetail.job_workflow){
      let array =[]
      applicationDetail?.job_workflow?.map((item)=>{
        if(item.name!="Job Application" && item.name!="Final Results & Appointment"){
          array.push(item.name)
        }
      })
      setWorkFlow(array)
    }
  },[applicationDetail])
  useEffect(() => {
 
    if(computerTestlist){
      let ddatas=[...computerTestlist]
      if(ddatas.length>0){
        ddatas.push({
          "computer_test_id": "7",
          "application_id": "4",
          "applicant_id": "5",
          "test_name": "Call Letter for Computer Based Test",
          "qus_count": "33",
          "test_venue": "No. 1 Nitel Road, Cappa Bus Stop, Oshodi, Lagos State, Nigeria",
          "test_date": "2025-02-28T14:17",
          "computer_test_status": true,
          "computer_test_current_status": "Call Letter Received",
          "computer_test_creaeted_at":  computerTestlist[0].computer_test_creaeted_at,
          "computer_test_updated_on": computerTestlist[0].computer_test_updated_on,
          "test_completed_time": "5328",
          "total_mark": "7",
          "total_ans_qus": "32",
          "not_ans_qus": "1",
          "correct_qus": "7",
          qus_data:[],
          "instructions": null,
          "test_reject_reason": null
        })
        
      }
      setComputeTestDetails(ddatas)
    }
    if(MedicaltestsList){
      let datasss =[...MedicaltestsList]
      if(datasss.length>0){
        datasss.push({
          "medical_test_id": "7",
          "application_id": "4",
          "applicant_id": "5",
          "medical_test_created_at": "1737716700843",
          "medical_test_status": true,
          "medical_test_current_status": "Call Letter Received",
          "medical_test_examined_at": "1737720216217",
          "medical_test_location": "Sagamu 121102, Ogun State, Nigeria",
          "medical_test_remarks": "Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role Mark as Candidate as Fit for this Role",
          "test_reject_reason": null,
          "medical_test_updated_on": "1737720216217",
          "test_type": "medical",
          "medical_test_name": "Medical Verification",
          "medical_test_examined": "e22138fa-3c91-4d74-a5cb-8e4f28273507",
          "medical_test_attachment": [],
          "medical_test_data": [],
          "admin_uuid": null,
          "agent_first_name": "Adeola",
          "agent_last_name": "Fashola",
          "agent_email": "feray10926@owube.com",
          "agent_mobile_number": "8123452525",
          "admin_first_name": null,
          "admin_last_name": null,
          "admin_email": null
        }) }
      setMedicalTestSupervisorDetails(datasss)
    }
    if(applicationDetail?.job_current_status=="Finalised"){
      setFinalResultDetails([{
        event:"Appointment Letter",
        last_updated_on:applicationDetail.job_updated_on,
        updatedBy:"",
        eventType:"Appointment Letter",
        status:"Finalised"
      }])
    }
  }, [activeStep, physicalTestSupervisorDetails?.length, computeTestDetails?.length, medicalTestSupervisorDetails?.length, finalResultDetails?.length,computerTestlist]);

  const HandleAttachmentValueChange = async(value, i, type) => {
    var updatedPhysicalData = [];
    if (type == "file") {
      const files = value.target.files && value.target.files[0];
      if (files) {
        const maxFileSize = 5 * 1024 * 1024;
        if (files.size > maxFileSize) {
          toast.error("File size exceeds 5MB. Please upload a smaller file.");
          return;
        }
        let today = Date.now()
        let Extention = String(files.name).split(".")

        let name = "attachments/attachment" + today + "." + Extention[Extention.length - 1];
        let contenttype = "application/pdf";
        if (Extention[Extention.length - 1] != "pdf") {
          contenttype = "image/png";
        }
        const data = await S3Upload({ name, file:files, contenttype });
        updatedPhysicalData = attachmentList.map((item, index) => {
          if (index === i) {
            return { ...item, fileName: files.name, fileType: files.type, fileUrl: data };
          }
          return item;
        });
      }
    } else if (type == "text") {
      updatedPhysicalData = attachmentList.map((item, index) => {
        if (index === i) {
          return { ...item, attachmentName: value };
        }
        return item;
      });
    }
    setAttachmentList(updatedPhysicalData);
  }
  const HandleNewAttachment = () => {
    try {
      attachmentList.map((row, i) => {
        if (row?.attachmentName?.trim().length === 0) {
          throw new Error(`Please Enter Attachment Name - ${i + 1}`);
        }
        if (!row.fileUrl) {
          throw new Error(`Please Upload Attachment File in  - ${row.attachmentName}`);
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    setAttachmentLoader(true)
    setAttachmentList([...attachmentList, { id: 1, attachmentName: "", fileName: "", fileType: "" }]);
    setAttachmentLoader(false)
  }

  const HandleChandidateChange = (value, name) => {
    let arr = {}
    if (name == "candidateFit" && value == true) {
      arr = { candidateFit: true, candidateNotFit: false, }
    } else if (name == "candidateNotFit" && value == true) {
      arr = { candidateFit: false, candidateNotFit: true, }
    } else {
      arr = { candidateFit: false, candidateNotFit: false, }
    }
    setRoleCheckBoxData(arr);
    setRejectReason("");
  }
  const CloseMedicalTestModal = () => {
    setMedicalScreening(false)
    setRemarks("");
    setRejectReason("");
    setAttachmentList([{ id: 1, attachmentName: "", fileName: "", fileType: "" }]);
    setPhysicalDataChild(PhysicalData);
    setRoleCheckBoxData({ candidateFit: false, candidateNotFit: false, })
  }
  const OpenMedicalTestModal = (value,item) => {
    if(item){
      setSelectedtests(item)
    }
    setMedicalScreening(true)
    setIsEdit(value)
  }
  const CloseAppointmentOfferModal = () => {
    setAppointmentOfferLetter(false);
    setPrimaryDuties("");
    setOfferLetterCheckBoxData({
      candidatePersonalInfo: false, candidateRequirement: false,
      candidateApplicationStage: false, candidateAllDocument: false,
      candidateFinalAppointment: false
    });
    setAppointmentData(AppointmentDataOtherInfomarion);
  }
  const OpenAppointmentOfferModal = (value,item) => {
    if(item?.physical_test_attachment){
      setAttachmentList(item.physical_test_attachment)
    }
    setSelectedtests(item)
    setAppointmentOfferLetter(true);
    setIsEdit(value)
  }
  const OpenAppointmentOfferModal1= (value,item) => {
    setSelectedtests(item)
    setAppointmentOfferLetter(true);
    setIsEdit(value)
  }
  const UpdateMedicialTest = () => {

    toast.success("Medical Screening Details Updated Successfully");
   
    CloseMedicalTestModal()
  }

  const UpdateVerifyCerticate = () => {
    toast.success("Verify Certificate Details Updated Successfully")
    GetApplicationDetails(paramss.id)
    CloseVerfiyCertificateModal();
  }
  const CloseVerfiyCertificateModal = () => {
    setCertificateVerifyModal(false);
    setRemarks("");
    setRejectReason("");
    setCandiateDetaildData(CandiateDetaildData);
    setQualificationLevelChildData(QualificationLevelData);
    setRoleCheckBoxData({ candidateFit: false, candidateNotFit: false, })
    setAttachmentList([{ id: 1, attachmentName: "", fileName: "", fileType: "" }]);
  }

  const OpenVerfiyCertificateModal = (value,item) => {
    if(item?.physical_test_attachment){
      setAttachmentList(item.physical_test_attachment)
    }
    setSelectedtests(item)
    setCertificateVerifyModal(true);
    if(UsersType=="superadmin"){
      setIsEdit(true)
    }else{
      setIsEdit(value)
    }

  }

  const ClosePhysicalModal = () => {
    setTakePhysicalModal(false);
    setDeficiencies("");
    setRemarks("");
    setRejectReason("");
    setRoleCheckBoxData({ candidateFit: false, candidateNotFit: false, })
  }
  const OpenPhysicalModal = (value,item) => {
    setSelectedtests(item)
    setTakePhysicalModal(true);
    setIsEdit(value)
  }

  const UpdateCandicateCerificate = () => {
    toast.success("Physical Data Details Updated Successfully")
    GetApplicationDetails(paramss.id)
    ClosePhysicalModal();
  }
  const OpenAppointmentCopy = () => {

    window.open(`/OfferLetterview/${applicationDetail.job_application_uuid}`);
    setApplicationCopyDetails(ConstableData[0])
  }
  const physicalNavigate = () => {
    window.open(`/physical/CallLetter/${applicationDetail.job_application_uuid}`);
    setApplicationCopyDetails(ConstableData[0])
  }
  const medicalNavigate = () => {
    window.open(`/medical/CallLetter/${applicationDetail.job_application_uuid}`);
  }
  const computerNavigate = () => {
    window.open(`/computer/CallLetter/${applicationDetail.job_application_uuid}`, "_blank")
  }
  const RejectModalOpen = () => {
    setAppointmentOfferLetter(false);
    setRejectModalOpen(true)
  }
  const CloseRejectModal = () => {
    setRejectModalOpen(false);
    setAppointmentOfferLetter(true);
  }
  const RejectCandiate = () => {
    toast.success("Candidate Rejected Successfully");
    if (rejectReason == "Other (Specify)") {
      if (!remarks) {
        toast.error("Please Enter Remarks");
        return
      }
    }
    if (remarks) {
      if (remarks?.trim().length == 0) {
        toast.error("Please Enter Valid Remarks");
        return
      }
    }
    setRejectModalOpen(false);
    setRejectReason("");
    setRemarks("");
  }

  const OpenComputerBasedTestModal = () => {
    setComputerBasedModal(true)
  }
  useEffect(()=>{
    GetCharmenSignatures()
  },[])
  const GetCharmenSignatures =async()=>{
    try{
      let url ="settings/signatureslist"
      let method = "GET"
      const response = await GetMethod({url,method})
      if(response.status){
        setCharmanSignatures(response.result[0].signature_file)
        setCharmanName(response.result[0].signature_name)
      }
    }catch(Error){
      console.log("err in GetCharmenSignatures",Error)
    }
  }
  const PhysicalTest=()=>{
    return(
      <>
        {( physicalTestSupervisorDetails.length>0)&&

          <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
            <h5 className="poppinsSemiBold Text-Prime-Black text-left"> Physical Tests</h5>
          </Grid>}
        {( physicalTestSupervisorDetails.length>0)&&
              <Grid item lg={12} sm={12} md={12} xs={12} >
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Event</StyledTableCell>
                        <StyledTableCell align="center">Last Updated on</StyledTableCell>
                        {localStorage.getItem("@userType") == "fieldagentsupervisor" && <StyledTableCell align="center">Updated By</StyledTableCell>}
                        <StyledTableCell align="center">Status</StyledTableCell>
                        <StyledTableCell align="center">Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {physicalTestSupervisorDetails?.map((item, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsRegular Text-Prime-Black">{item.physical_test_name}</p>
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.physical_test_updated_on ? OnlyDateTimeConverter(item.physical_test_updated_on) : "--"}
                              </p>
                            </StyledTableCell>
                            {localStorage.getItem("@userType") == "fieldagentsupervisor" && <StyledTableCell align="center">
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.agent_first_name ? item.agent_first_name : "--"}{" "}
                                {item.agent_last_name ? item.agent_last_name : "--"}
                              </p>
                            </StyledTableCell>}
                            <StyledTableCell align="center">
                              <p className={StatusStyle(item.physical_test_current_status)}>{item.test_type ? (item.test_type + "-") : ""}{item.physical_test_current_status ? item.physical_test_current_status : "-"}</p>
                            </StyledTableCell>
                            <StyledTableCell align="center">

                              {(item.physical_test_current_status?.toLowerCase() == "pending" && item.test_type?.toLowerCase() == "physical" && localStorage.getItem("@userType") != "applicant") ?
                                <GreenColorButton
                                  type="submit"
                                  className="px-3 py-2 ml-3"
                                  onClick={() => OpenPhysicalModal(true,item)}
                                >
                                  Take Physical Details
                                </GreenColorButton> : (item.physical_test_current_status?.toLowerCase() == "pending" && item.test_type?.toLowerCase() == "certificate" && localStorage.getItem("@userType") != "applicant") ?
                                  <GreenColorButton
                                    type="submit"
                                    className="px-3 py-2 ml-3"
                                    onClick={() => OpenVerfiyCertificateModal(true,item)}
                                  >
                                    Verify Certificates
                                  </GreenColorButton> : ((item.physical_test_current_status?.toLowerCase() == "rejected" || item.physical_test_current_status?.toLowerCase() == "approved") && item.test_type?.toLowerCase() == "physical") ?
                                    <GreenColorButton
                                      type="submit"
                                      className="px-3 py-2 ml-3"
                                      onClick={() => OpenPhysicalModal(false,item)}

                                    >
                                      View Details
                                    </GreenColorButton> : ((item.physical_test_current_status?.toLowerCase() == "rejected" || item.physical_test_current_status?.toLowerCase() == "verified") && item.test_type?.toLowerCase() == "certificate") ?
                                      <GreenColorButton
                                        type="submit"
                                        className="px-3 py-2 ml-3"
                                        onClick={() => OpenVerfiyCertificateModal(false,item)}

                                      >
                                        View Details
                                      </GreenColorButton> : (item.physical_test_name=="Call Letter for Physical") ?
                                        <GreenColorButton
                                          type="submit"
                                          className="px-3 py-2 ml-3"
                                          onClick={() => {if(applicationDetail?.job_application_uuid) physicalNavigate()}}
                                        >
                                          View Call Letter
                                        </GreenColorButton> : "--"}
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}

                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>}
      </>
    )
  }
  const ComputerTest=()=>{
    return(
      <>
        {computeTestDetails?.length > 0 &&
          <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-2">
            <h5 className="poppinsSemiBold Text-Prime-Black text-left">
              Computer Based Test
            </h5>
          </Grid>}
        {computeTestDetails?.length > 0 &&
            <Grid item lg={12} sm={12} md={12} xs={12} >
              <TableContainer className="mt-3">
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Event</StyledTableCell>
                      <StyledTableCell align="center">Last Updated on</StyledTableCell>
                      <StyledTableCell align="center">Updated By</StyledTableCell>
                      <StyledTableCell align="center">Status</StyledTableCell>
                      <StyledTableCell align="center">Action</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {computeTestDetails?.map((item, i) => {
                      return (
                        <StyledTableRow key={i}>
                          <StyledTableCell align="left">
                            <p className="poppinsRegular Text-Prime-Black">{item?.test_name? item.test_name:"Computer Based Test"}</p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <p className="poppinsRegular Text-Prime-Black">                               
                              {item.computer_test_updated_on ? OnlyDateTimeConverter(item.computer_test_updated_on) : "--"}
                            </p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <p className="poppinsRegular Text-Prime-Black">
                              {item.updatedBy ? item.updatedBy : "Admin"}
                            </p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <p className={StatusStyle(item.computer_test_current_status)}>{item.eventType ? (item.eventType + "-") : ""}{item.computer_test_current_status ? item.computer_test_current_status : "-"}</p>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {(item.status?.toLowerCase() == "pending" && item.eventType?.toLowerCase() == "physical") ?
                              <GreenColorButton
                                type="submit"
                                className="px-3 py-2 ml-3"                                  onClick={() => OpenPhysicalModal(false,item)}
                              >
                                Take Physical Details
                              </GreenColorButton> : (item.status?.toLowerCase() == "pending" && item.eventType?.toLowerCase() == "medical") ?
                                <GreenColorButton
                                  type="submit"
                                  className="px-3 py-2 ml-3"
                                  onClick={() => OpenMedicalTestModal(false,item)}
                                >
                                  Verify Medical
                                </GreenColorButton> : ((item.computer_test_current_status?.toLowerCase() == "failed" || item.computer_test_current_status?.toLowerCase() == "completed")) ?
                                  <GreenColorButton
                                    type="submit"
                                    className="px-3 py-2 ml-3"
                                    onClick={() => OpenComputerBasedTestModal()}
                                  >
                                    View Details
                                  </GreenColorButton>
                                  : (item.test_name=="Call Letter for Computer Based Test") ?
                                    <GreenColorButton
                                      type="submit"
                                      className="px-3 py-2 ml-3"
                                      onClick={() => computerNavigate()}
                                    >
                                      View Call letter
                                    </GreenColorButton> : "" 
                            }
                          </StyledTableCell>
                        </StyledTableRow>)})}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>}
      </>
    )
  }
  const MedicalTest=()=>{
    return(
      <>
        {medicalTestSupervisorDetails?.length > 0 &&
          <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-2">
            <h5 className="poppinsSemiBold Text-Prime-Black text-left">Medical Screening Test</h5>
          </Grid>}
        {medicalTestSupervisorDetails?.length > 0 &&
          <Grid item lg={12} sm={12} md={12} xs={12} >
            <TableContainer className="mt-3">
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Event</StyledTableCell>
                    <StyledTableCell align="center">Last Updated on</StyledTableCell>
                    <StyledTableCell align="center">Updated By</StyledTableCell>
                    <StyledTableCell align="center">Status</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {medicalTestSupervisorDetails.map((item, i) => {
                    return (
                      <StyledTableRow key={i}>
                        <StyledTableCell align="left">
                          <p className="poppinsRegular Text-Prime-Black">{item.medical_test_name? item.medical_test_name:"---"}</p>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <p className="poppinsRegular Text-Prime-Black">
                            {item.medical_test_updated_on ? OnlyDateTimeConverter(Number(item.medical_test_updated_on)) : "---"}
                          </p>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <p className="poppinsRegular Text-Prime-Black">
                            {item.agent_first_name ? item.agent_first_name +" "+item?.agent_last_name : "--"}
                            {!item?.agent_first_name? item.admin_first_name ? item.admin_first_name +" "+item?.admin_last_name : "--":""}
                          </p>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <p className={StatusStyle(item.medical_test_current_status)}>{item.eventType ? (item.eventType + "-") : ""}{item.medical_test_current_status ? item.medical_test_current_status : "-"}</p>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {(item.status?.toLowerCase() == "pending" && item.eventType?.toLowerCase() == "physical") ?
                            <GreenColorButton type="submit" className="px-3 py-2 ml-3" onClick={() => OpenPhysicalModal(false,item)} >
                              Take Physical Details
                            </GreenColorButton> : (item.medical_test_current_status?.toLowerCase() == "pending" && item.medical_test_current_status?.toLowerCase() == "medical") ?
                              <GreenColorButton type="submit" className="px-3 py-2 ml-3" onClick={() => OpenMedicalTestModal(true,item)} >
                                Verify Medical
                              </GreenColorButton> : ((item.medical_test_current_status?.toLowerCase() == "rejected" || item.medical_test_current_status?.toLowerCase() == "approved") ) ?
                                <GreenColorButton type="submit"className="px-3 py-2 ml-3" onClick={() => OpenMedicalTestModal(false,item)} >
                                  View Details
                                </GreenColorButton>
                                : (item?.medical_test_current_status=="Call Letter Received") ?
                                  <GreenColorButton type="submit" className="px-3 py-2 ml-3" onClick={() => {if(applicationDetail?.job_application_uuid) medicalNavigate()}}>
                                    View Call letter
                                  </GreenColorButton> :""
                          }
                        </StyledTableCell>
                      </StyledTableRow>)})}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>}
      </>
    )
  }

  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} >
   
      {(localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin") ? <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2">
        {activeStep == 0 ?
          <Grid item lg={12} sm={12} md={12} xs={12}>
            <p className="poppinsRegular Text-Prime-Black text-center">
              Application Under Review
            </p>
          </Grid> : activeStep == 1 &&
          <Grid item lg={12} sm={12} md={12} xs={12}>
            <p className="poppinsRegular Text-Prime-Black text-center">
              Not Processed Yet
            </p>
          </Grid>}
        <Grid item lg={12} sm={12} md={12} xs={12} container>
          {activeStep >= 1 &&
            <>
              {physicalTest?.map((item,i)=>{
                return(
                  <> 
                    <Grid item lg={12} key={i} sm={12} md={12} xs={12} className="p-3">
                      <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                        <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                          Physical Test - Data Entry
                        </h5>
                        <Grid item className={"w-20 mx-2"}>
                          <p className={StatusStyle(item.physical_test_current_status)}>{item.physical_test_current_status}</p>
                        </Grid>
                      </Grid>
                      
                      <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"flex-start"} justifyContent={"space-between"}>
                        
                        <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                          <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                            <Grid item lg={6} sm={6} md={6} xs={6}>
                              <p className="poppinsMedium Text-Prime-Black text-left">
                                Examined by
                              </p>
                            </Grid>
                            <Grid item lg={6} sm={6} md={6} xs={6} >
                              <p className="poppinsRegular Text-Prime-Black text-left">
                                {item?.agent_first_name}{" "}{item?.agent_last_name}
                              </p>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                        </Grid>
                        <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                          <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                            <Grid item lg={6} sm={6} md={6} xs={6}>
                              <p className="poppinsMedium Text-Prime-Black text-left">
                                Examined on
                              </p>
                            </Grid>
                            <Grid item lg={6} sm={6} md={6} xs={6} >
                              <p className="poppinsRegular Text-Prime-Black text-left">
                                {OnlyDateTimeConverter(Number(item.physical_test_examined_at))}
                              </p>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" >
                          <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
                            <p className="poppinsMedium Text-Prime-Black text-left">
                              Remarks
                            </p>
        
                            <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                              {item?.physical_test_remarks}
                            </p>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container item lg={12} sm={12} md={12} xs={12} justifyContent={"flex-end"} >
                        <PrimeGrayBorderColorButton
                          type="submit"
                          className="px-3 py-2"
                          onClick={() => OpenVerfiyCertificateModal(false,item)}
                        >
                          View
                        </PrimeGrayBorderColorButton>
                      </Grid>
                    </Grid> 
                    {activeStep >= 2 &&
                      <Divider className="m-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                    }
                  </>
                  
                )
              })}
            </>
          }
          {activeStep >= 3 &&
            <Divider className="m-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          }
          {activeStep >= 3 &&
            <Grid item lg={12} sm={12} md={12} xs={12} className="p-3">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Computer Based Test
                </h5>
                <Grid item className={"w-20 mx-2"}>
                  <p className={StatusStyle("Passed")}>Passed</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"flex-start"} justifyContent={"space-between"}>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Registration Number
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {ApplicationBasicDetails.RegisterNumber}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Test Date
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(1744083351000)}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Answer Sheet
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular TextUnderGreen pointer text-left">View</p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Total Marks Obtained
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        90 out of 100
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Result Published on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(1764083351000)}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Remarks
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {ApplicationBasicDetails.Remarks}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>}
          {activeStep >= 4 &&
            <Divider className="m-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          }
          {activeStep >= 4 &&
            <Grid item lg={12} sm={12} md={12} xs={12} className="p-3">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Medical Screening Test
                </h5>
                <Grid item className={"w-20 mx-2"}>
                  <p className={StatusStyle("Passed")}>Passed</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"flex-start"} justifyContent={"space-between"}>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Test Date
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(1764083351000)}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(1744083351000)}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Weight
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        68 kg
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Systolic Pressure
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        120 mmHg
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Blood Group
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        O+
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined by
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Okeke Uchechukwu
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Height
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        170 cm
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        BMI Status
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        23.5 (Normal)
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Diastolic Pressure
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        80 mmHg
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" flexDirection={"column"}>
                  <p className="poppinsMedium Text-Prime-Black text-left">
                    Remarks
                  </p>
                  <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                    General Fitness: Candidate is either Fit for Duty, meeting all required fitness levels; has Marginal Fitness, being close to minimum standards; or is Below Fitness Standards, not meeting role requirements.
                  </p>
                </Grid>
              </Grid>
              <Grid container item lg={12} sm={12} md={12} xs={12} justifyContent={"flex-end"} >
                <PrimeGrayBorderColorButton
                  type="submit"
                  className="px-3 py-2"
                  onClick={() => { OpenMedicalTestModal(false); }}
                >
                  View
                </PrimeGrayBorderColorButton>
              </Grid>
            </Grid>}
          {activeStep >= 5 &&
            <Divider className="m-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          }
          {activeStep >= 5 &&
            <Grid item lg={12} sm={12} md={12} xs={12} className="p-3">
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"}>
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Final Results & Appointment
                </h5>
                <Grid item className={"w-20 mx-2"}>
                  <p className={StatusStyle("Passed")}>Completed</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} container className="p-2" alignItems={"flex-start"} justifyContent={"space-between"}>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Appointment Status
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Issued
                      </p>

                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Result Published on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(1744083351000)}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />

                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left" >
                        Appointment Copy
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} role="presentation" onClick={() => OpenAppointmentCopy()}>
                      <p className="poppinsRegular TextUnderGreen pointer text-left">View</p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={5.9} sm={5.9} md={5.9} xs={5.9} container className="p-2" alignItems={"center"}>
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Published by
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Okeke Uchechukwu
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Okeke Uchechukwu
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        PSC/CONS/123456
                      </p>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} sm={12} md={12} xs={12} container style={{ borderBottom: "2px dotted black", }} />
                  <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" justifyContent={"space-between"}>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Remarks
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6} >
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {ApplicationBasicDetails.Remarks ? ApplicationBasicDetails.Remarks : "--"}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container item lg={12} sm={12} md={12} xs={12} justifyContent={"flex-end"} >
                <PrimeGrayBorderColorButton
                  type="submit"
                  className="px-3 py-2"
                  onClick={() => OpenAppointmentOfferModal(true)}
                >
                  View
                </PrimeGrayBorderColorButton>
              </Grid>
            </Grid>
          }
        </Grid>
      </Grid>
        : (localStorage.getItem("@userType") == "fieldagentsupervisor" || localStorage.getItem("@userType") == "applicant") ?
          <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2">
            {localStorage.getItem("@userType") == "applicant" && applicationDetail?.applications_accepted==false && (activeStep == 0 ?
              <Grid item lg={12} sm={12} md={12} xs={12} className="pb-2" >
                <p className="poppinsRegular Text-Prime-Black text-center">
                  Application Under Review
                </p>
              </Grid> : activeStep == 10 &&
                <Grid item lg={12} sm={12} md={12} xs={12} className="pb-2" >
                  <p className="poppinsRegular Text-Prime-Black text-center">
                    Not Processed Yet
                  </p>
                </Grid>)
            }
            {WorkFlow?.map((item)=>{return(
              <>{
                item =="Physical Test"? <PhysicalTest/> : item =="Computer Based Test"? <ComputerTest  /> :item =="Medical Screening"&& <MedicalTest/>
              }</>
            )})}
            {finalResultDetails?.length > 0 &&
              <Grid item lg={12} sm={12} md={12} xs={12} container flexDirection={"row"} alignItems={"center"} className="pt-2">
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Final Results & Appointment
                </h5>
              </Grid>}
            {finalResultDetails?.length > 0 &&
              <Grid item lg={12} sm={12} md={12} xs={12} >
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Event</StyledTableCell>
                        <StyledTableCell align="center">Last Updated on</StyledTableCell>
                        <StyledTableCell align="center">Updated By</StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                        <StyledTableCell align="center">Action</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {finalResultDetails.map((item, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsRegular Text-Prime-Black">{item.event}</p>
                            </StyledTableCell>

                            <StyledTableCell align="center"> 
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.last_updated_on ? OnlyDateTimeConverter(item.last_updated_on) : "--"}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.updatedBy ? item.updatedBy : "--"}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <p className={StatusStyle(item.status)}>{item.eventType ? (item.eventType + "-") : ""}{item.status ? item.status : "-"}</p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {item.status?.toLowerCase() == "finalised" ?
                                <GreenColorButton
                                  type="submit"
                                  className="px-3 py-2 ml-3"
                                  onClick={() => OpenAppointmentOfferModal1(false)}
                                >
                                  View Details
                                </GreenColorButton>
                                : "--"}
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}

                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>}
          </Grid> : ""}



      <TakeMedicalScreeningDetails
        medicalScreening={medicalScreening}
        setMedicalScreening={setMedicalScreening}
        CloseMedicalTestModal={CloseMedicalTestModal}
        UpdateMedicialTest={UpdateMedicialTest}
        physicalDataChild={physicalDataChild}
        setPhysicalDataChild={setPhysicalDataChild}
        applicationDetail={applicationDetail}
        attachmentList={attachmentList}
        attachmentLoader={attachmentLoader}
        roleCheckBoxData={roleCheckBoxData}
        HandleChandidateChange={HandleChandidateChange}
        remarks={remarks}
        setRemarks={setRemarks}
        HandleAttachmentValueChange={HandleAttachmentValueChange}
        HandleNewAttachment={HandleNewAttachment}
        BloodGroupList={BloodGroupList}
        rejectReason={rejectReason}
        setRejectReason={setRejectReason}
        isEdit={isEdit}
        Selectedtests={Selectedtests}
        CandidateDetail={CandidateDetail}
        MedicalDataChild={MedicalDataDetails}
      />
      <VerifyCertificateDetailsModal
        applicationDetail={applicationDetail}
        certificateVerifyModal={certificateVerifyModal}
        setCertificateVerifyModal={setCertificateVerifyModal}
        UpdateVerifyCerticate={UpdateVerifyCerticate}
        CloseVerfiyCertificateModal={CloseVerfiyCertificateModal}
        remarks={remarks}
        setRemarks={setRemarks}
        roleCheckBoxData={roleCheckBoxData}
        HandleChandidateChange={HandleChandidateChange}
        attachmentList={attachmentList}
        attachmentLoader={attachmentLoader}
        candiateDetaildData={candiateDetaildData}
        setCandiateDetaildData={setCandiateDetaildData}
        qualificationLevelChildData={qualificationLevelChildData}
        setQualificationLevelChildData={setQualificationLevelChildData}
        HandleAttachmentValueChange={HandleAttachmentValueChange}
        HandleNewAttachment={HandleNewAttachment}
        rejectReason={rejectReason}
        setRejectReason={setRejectReason}
        isEdit={isEdit}
        Selectedtests={Selectedtests}
        CandidateDetail={CandidateDetail}
      />
      <TakePhysicalDataDetails
        applicationDetail={applicationDetail}
        takePhysicalModal={takePhysicalModal}
        setTakePhysicalModal={setTakePhysicalModal}
        ClosePhysicalModal={ClosePhysicalModal}
        physicalDetails={physicalDetails}
        setPhysicalDetails={setPhysicalDetails}
        deficiencies={deficiencies}
        setDeficiencies={setDeficiencies}
        UpdateCandicateCerificate={UpdateCandicateCerificate}
        remarks={remarks}
        setRemarks={setRemarks}
        roleCheckBoxData={roleCheckBoxData}
        HandleChandidateChange={HandleChandidateChange}
        rejectReason={rejectReason}
        setRejectReason={setRejectReason}
        isEdit={isEdit}
        Selectedtests={Selectedtests}
        setCertificateVerifyModal={setTakePhysicalModal}
      />
      <FinalAppointmentDetails
        appointmentOfferLetter={appointmentOfferLetter}
        setAppointmentOfferLetter={setAppointmentOfferLetter}
        CloseAppointmentOfferModal={CloseAppointmentOfferModal}
        offerLetterCheckBoxData={offerLetterCheckBoxData}
        setOfferLetterCheckBoxData={setOfferLetterCheckBoxData}
        applicationDetail={applicationDetail}
        primaryDuties={primaryDuties}
        setPrimaryDuties={setPrimaryDuties}
        appointmentData={appointmentData}
        setAppointmentData={setAppointmentData}
        RejectModalOpen={RejectModalOpen}
        isEdit={isEdit}
        CandidateDetail={CandidateDetail}
        OpenAppointmentCopy={OpenAppointmentCopy}
      />

      <ComputerBasedTest
        computerBasedModal={computerBasedModal}
        setComputerBasedModal={setComputerBasedModal}
        applicationDetail={applicationDetail}
        computeTestDetails={computeTestDetails[0]}
        CandidateDetail={CandidateDetail}
      />

      <CustomModal
        open={rejectModalOpen}
        setOpen={CloseRejectModal}
        divider={false}
        header={true}
        width={"50%"}
        modalTitle={
          <h5 className="poppinsSemiBold Text-Prime-Black text-left">
            Reject Candidate
          </h5>
        }
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
              <Grid item container >
                <p className="poppinsMedium Text-Prime-Black text-left w-100">
                  Reason for Rejection
                </p>
              </Grid>
              <Grid item className="py-2 w-50">
                <CustomDropDown
                  placeholder={"Please Select Reason"}
                  borderRadius={"8px"}
                  data={RejectionsInfo}
                  isFixed={rejectReason == "Other (Specify)" ? false : true}
                  selected={
                    rejectReason && {
                      label: rejectReason,
                      value: rejectReason,
                    }
                  }
                  onChange={(option) => { setRejectReason(option?.value); setRemarks(""); }}
                />
              </Grid>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} container className="py-2" flexDirection={"column"}>
              <Grid item container >
                <p className="poppinsMedium Text-Prime-Black text-left w-100">
                  Remarks
                </p>
              </Grid>
              <Grid item className="py-2" container>
                <TextAreaField
                  placeholder="Enter the Remarks If Any"
                  fontSize={14}
                  backgroundColor="#FFFFFF"
                  width={"100%"}
                  maxLength={1000}
                  padding={"2.5% 3% 2.5% 0%"}
                  placeholderColor="#666666"
                  border={"1px solid  #666666"}
                  fontFamily={"PoppinsMedium"}
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid item lg={12} md={12} sm={12} xs={12} container justifyContent={"flex-end"}>
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => CloseRejectModal()}
            >
              CANCEL
            </PrimeGrayBorderColorButton>
            <RedColorButton
              type="submit"
              className="px-3 py-2 ml-3"
              onClick={() => RejectCandiate()}
            >
              Reject
            </RedColorButton>
          </Grid>
        }
      />

      <CallLetterModal 
        callLetter={callLetter}
        setCallLetter={setCallLetter}
        heading={callLetterHeading}
        CandidateDetail={CandidateDetail}
        applicationDetail={applicationDetail}
        postName={"Cadet Assistant Superintendent of Police"}
        year={"2024 - 2025"}
        callLetterDetails={callLetterDetails}
        CharmanName={CharmanName}
        CharmanSignatures={CharmanSignatures}
        callLetterName={CalletterName}
        
      />
      <OfferLetterModal 
        offerLetterModal={offerLetterModal}
        setOfferLetterModal={setOfferLetterModal}
        applicationDetail={applicationDetail}
        applicationCopyDetails={applicationCopyDetails}
        GetApplicationDetails={appointmentData}
        CandidateDetail={CandidateDetail}
        CharmanSignatures={CharmanSignatures}
        CharmanName={CharmanName}
      />
    </Grid>
  );
};

export default ApplicationProcess;
